import { useMemo } from "react";
import {
  useGetSourcingEventReadinessQuery,
  FieldKeys,
  Gate,
  type FieldStatusDto,
  type ProcedureType,
} from "../../../../../autogen/bff-api";

export type KnownFieldKey = `${FieldKeys}`;

export type ReadinessLookup = (fieldKey: KnownFieldKey) => FieldStatusDto | undefined;

export interface UseReadinessByFieldResult {
  readinessFor: ReadinessLookup;
  isPublishReady: boolean;
  refusedProcedure: ProcedureType | null;
  isLoading: boolean;
  isError: boolean;
}

export const useReadinessByField = (eventId: string): UseReadinessByFieldResult => {
  const { data, isLoading, isError } = useGetSourcingEventReadinessQuery({ eventId });

  const readinessFor = useMemo<ReadinessLookup>(() => {
    const lookup = new Map<string, FieldStatusDto>();
    if (data?.fields) {
      for (const status of data.fields) {
        lookup.set(status.fieldKey, status);
      }
    }
    return (fieldKey) => lookup.get(fieldKey);
  }, [data]);

  const isPublishReady = useMemo(() => {
    const publishFields = data?.fields.filter((f) => f.gate === Gate.Publish) ?? [];
    return publishFields.length > 0 && publishFields.every((f) => f.satisfied);
  }, [data]);

  return { readinessFor, isPublishReady, refusedProcedure: data?.refusedProcedure ?? null, isLoading, isError };
};
